import React from 'react';
import {useStyles} from "../ArticleCategories.style";
import clsx from "clsx";
import ArticleCategoryRowProperties from "./ArticleCategoryRowProperties";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import ButtonType from "../../../ui_components/Button/ButtonType";
import ExpandoMenu from '../../../ui_components/ExpandoMenu/ExpandoMenu';
import ShowText from '../../../shared_components/Info/ShowText/ShowText';
import ShowArticleDescription from '../../../shared_components/Info/ShowArticleDescription/ShowArticleDescription';
import NewArticleCategoryButton from '../../../shared_components/Buttons/NewArticleCategory/NewArticleCategoryButton';
import RemoveArticleCategoryButton from '../../../shared_components/Buttons/RemoveArticleCategory/RemoveArticleCategoryButton';
import AllowAccess from '../../../shared_components/Access/AllowAccess/AllowAccess';
import Access from '../../../shared_components/Access/AllowAccess/Access';


const ArticleCategoryRowMedium: React.FC<ArticleCategoryRowProperties> = ({
                                                            articleCategory,
                                                            onUpdate = () => {
                                                            },
                                                        }) => {


    const classes = useStyles();

    return (
        <div
            className={clsx(classes.article_category_info_container)}>
            <ShowText text={articleCategory.name} className={classes.article_category_name_container}/>
            <ShowArticleDescription description={articleCategory.description ?? '-'}/>
            <AllowAccess any={[Access.CREATE_ARTICLE_CATEGORY, Access.REMOVE_ARTICLE_CATEGORY]}>
                <ExpandoMenu>
                    <>
                        <NewArticleCategoryButton
                            size={ButtonSize.SMALL}
                            onSave={onUpdate}
                            articleCategoryId={articleCategory.id}
                            showText
                            type={ButtonType.SECONDARY}
                        />
                        <RemoveArticleCategoryButton
                            size={ButtonSize.SMALL}
                            onSave={onUpdate}
                            articleCategory={articleCategory}
                            showText
                            type={ButtonType.SECONDARY}
                        />
                    </>
                </ExpandoMenu>
            </AllowAccess>
        </div>
    )
}

export default ArticleCategoryRowMedium;

